module.exports = __webpack_public_path__ + "first-100_microprint.jpg?de77780d9aebc1508efa67ec4939b21d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-100_microprint.jpg
// module id = 431
// module chunks = 0